import { HomePage, TasksPage, ProfilePage, SubjectsPage, OffersPage, DocumentsPage, ProjectsPage, PaymentCondPage, PaymentModalPage, CurrenciesPage, ArticlesPage, UsersPage, CountersPage, CustomerOrdersPage, SupplierOrdersPage, ActivitiesPage, CollaboratorsPage, TimetablePage, CustomerInvoicesPage, SupplierInvoicesPage, FenoticesPage, CompanyManagementPage, AnalyticsCategoriesPage, OffersProgressPage, PaymentsPage, OfferActivitiesPage, DocumentCategoriesPage, OffersBySupplierPage, CostsPage, JournalEntryPage, FecloudPage, ProjectActivitiesPage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/tasks',
        element: TasksPage
    },
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home',
        element: HomePage
    }, 
  {
    path: '/subjects',
    element: SubjectsPage
  }, 
  {
    path: '/offers',
    element: OffersPage
  }, 
  {
    path: '/documents',
    element: DocumentsPage
  }, 
  {
    path: '/projects',
    element: ProjectsPage
  }, 
  {
    path: '/payment-cond',
    element: PaymentCondPage
  }, 
  {
    path: '/payment-modal',
    element: PaymentModalPage
  }, 
  {
    path: '/currencies',
    element: CurrenciesPage
  }, 
  {
    path: '/articles',
    element: ArticlesPage
  }, 
  {
    path: '/users',
    element: UsersPage
  }, 
  {
    path: '/counters',
    element: CountersPage
  }, 
  {
    path: '/customer-orders',
    element: CustomerOrdersPage
  }, 
  {
    path: '/supplier-orders',
    element: SupplierOrdersPage
  }, 
  {
    path: '/activities',
    element: ActivitiesPage
  }, 
  {
    path: '/collaborators',
    element: CollaboratorsPage
  }, 
  {
    path: '/timetable',
    element: TimetablePage
  }, 
  {
    path: '/customer-invoices',
    element: CustomerInvoicesPage
  }, 
  {
    path: '/supplier-invoices',
    element: SupplierInvoicesPage
  }, 
  {
    path: '/fenotices',
    element: FenoticesPage
  }, 
  {
    path: '/company-management',
    element: CompanyManagementPage
  }, 
  {
    path: '/analytics-categories',
    element: AnalyticsCategoriesPage
  }, 
  {
    path: '/offers-progress',
    element: OffersProgressPage
  }, 
  {
    path: '/payments',
    element: PaymentsPage
  }, 
  {
    path: '/offer-activities',
    element: OfferActivitiesPage
  }, 
  {
    path: '/document-categories',
    element: DocumentCategoriesPage
  }, 
  {
    path: '/offers-by-supplier',
    element: OffersBySupplierPage
  }, 
  {
    path: '/costs',
    element: CostsPage
  }, 
  {
    path: '/journal-entry',
    element: JournalEntryPage
  }, 
  {
    path: '/fecloud',
    element: FecloudPage
  }, 
  {
    path: '/project-activities',
    element: ProjectActivitiesPage
  }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
